// filepath: apps/web/src/editors/bpm-designer/BpmDesignerRoute.tsx
//
// FR-UI-BLD-1 AC-5 - staging-only gate. URL:
//   /admin/processes/new
//   /admin/processes/:name/edit
//
// The SPA gates the route via the existing StagingOnlyError. The
// server additionally returns HTTP 403 ENV_PRODUCTION (ISS-254).

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { BpmDesignerPage } from "./BpmDesignerPage";

interface BpmDesignerRouteProps {
  environmentKind: string;
  name?: string;
}

export function BpmDesignerRoute({
  environmentKind,
  name: _name,
}: BpmDesignerRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <BpmDesignerPage environmentKind={environmentKind} />;
}
